import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Member, UpdateOwner } from "@/model";
import memberRepository from "@/repository/memberRepository";
import { memberQueryKeys } from "./keys";


export const useUpdateOwner = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<Member, AxiosError, UpdateOwner>({
        mutationKey: ["member", "owner", "update", agentId],
        mutationFn: async (form: UpdateOwner) => {
            try {
                const { data } = await memberRepository.updateOwner(agentId, form);
                return data.result;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: memberQueryKeys.all(agentId)
            });
        }
    });
};
